import templateOnly from '@ember/component/template-only';

/**
 * Renders attachment-capable visitor documents (e.g. COVID / vaccination) as a list of
 * `Visitors::DocumentManager` cards. Shared by the invite create/edit form (`Invites::SinglePrereg`)
 * and the entry form so the markup lives in one place instead of being duplicated across both.
 *
 * Args: `@documents` (VisitorDocumentModel[]), `@configurations` (template configurations matched by
 * `identifier`), `@onFileSelected`, `@onFilePreview`, `@onReset`, `@timezone`, `@disableReset`.
 */
export default templateOnly();
